// The words on the public My Trading Journey page (JourneyLanding.js), shared with the
// server's prerender (prerender.js journeyPage) so search engines read the same page.

export const JOURNEY_PATHS = { en: '/my-trading-journey', es: '/es/my-trading-journey' };

export const JOURNEY_HERO = {
  eyebrow: 'My Trading Journey',
  title: 'Is trading actually paying off?',
  sub: 'Every prop firm fee, every reset, every payout and every dollar you spent on trading, added up in real money. Then whether you’re getting better, and what your edge really is.',
};

// The three parts: id (the app page the demo opens), title, the question, what it shows.
export const JOURNEY_PARTS_TEXT = [
  {
    id: 'profitable', to: '/app/journey/profitable', title: 'Am I profitable?',
    lead: 'Real money only. What you paid the firms, what they paid you, and everything else trading cost you.',
    points: [
      'Your net result with the math written out: payouts minus evaluations, resets and activation fees.',
      'Prop firms, personal accounts or all together, for all time, a year or the last 3 months.',
      'A money statement by month, quarter or year, with a running total.',
      'Every prop account: what it cost, what it paid, how long it lasted and how it ended.',
      'A ledger of every entry, and a CSV for your accountant. Click any number to see what’s behind it.',
    ],
    demo: 'See Am I profitable? in the demo',
  },
  {
    id: 'better', to: '/app/journey/better', title: 'Am I getting better?',
    lead: 'Skill, not money. Your first months next to your latest, measured the same way.',
    points: [
      'Then vs now with any two stretches, and a better, worse or same verdict for 14 measures.',
      '“Not enough yet” when a sample is too small to mean anything.',
      'Trends by month, quarter or year: win rate, average loss, revenge trades, pass rate and more.',
      'How long every prop account lasted, oldest to newest.',
      'The lessons from your blown accounts, and the changes that turned things around.',
    ],
    demo: 'See Am I getting better? in the demo',
  },
  {
    id: 'edge', to: '/app/journey/edge-milestones', title: 'My edge & milestones',
    lead: 'What works over your whole career, not just this month, and the story it made.',
    points: [
      'Every setup with its result year by year. An edge only after 30 trades, green most years.',
      'The behaviors that cost you the most, since the day you started.',
      'Your journey in chapters, with real money and simulated results kept apart.',
      'Milestones that matter: first pass, first payout, an account that lasted 30 days, going live.',
    ],
    demo: 'See My edge & milestones in the demo',
  },
];

export const JOURNEY_WHY = [
  ['Real money, never simulated', 'Evaluation and funded-account profits aren’t money in your pocket. Only payouts, fees and your own accounts count as money here.'],
  ['One place for every firm', 'Topstep, Apex, Lucid, Tradeify, MyFundedFutures and the rest, side by side, with your own results for each.'],
  ['Honest about small samples', 'Nothing gets called better, worse or an edge until there’s enough data to say so.'],
];

export const JOURNEY_FAQ = [
  ['Does it count my evaluation profits as money?', 'No. Evaluation and funded-account results are simulated money. They show up as performance on Am I getting better?, but your money result only counts what you paid and what you were paid.'],
  ['Do I have to type in my fees?', 'You log each fee once, in a few seconds, and monthly fees can repeat on their own. Payouts come from the payouts you record on your funded accounts. Your trades come in from your platform.'],
  ['Does it work with personal accounts too?', 'Yes. Personal accounts count your trading profit minus your costs. Deposits and withdrawals are your own money moving, so they don’t count as profit or loss.'],
  ['Is it free?', 'My Trading Journey is part of Pro. Every new member gets 14 days of every feature free, no credit card, and the core journal stays free.'],
];
